import { Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "../../../../constants";

interface ContainerProps {
  zoomfactor: number;
}

export const ExamSheetContainer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: `${2480 * zoomfactor}px`,
  aspectRatio: "1 / 1.414",
  border: "1px solid #ddd",
  margin: "24px 0 24px 0",
  overflow: "hidden",
  position: "relative",
  backgroundColor: "#fff",
  boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
  display: "flex",
  flexDirection: "column",
  marginRight: "64px",
}));

export const TopSpacer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  height: `${129 * zoomfactor}px`,
}));

export const TitleBox = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  padding: `0 ${142 * zoomfactor}px 0 ${142 * zoomfactor}px`,
  display: "flex",
  justifyContent: "space-between",
}));

export const ExamTitle = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  padding: `0 ${8 * zoomfactor}px`,
  fontSize: `${70 * zoomfactor}px`,
  fontFamily: "TisaSansPro-Bold",
}));

export const HandWritingBox = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  gap: `${33 * zoomfactor}px`,
  width: `${784 * zoomfactor}px`,
  display: "flex",
  alignItems: "baseline",
}));

export const HandWriting = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${50 * zoomfactor}px`,
  fontFamily: "TisaSansPro-Italic",
}));

export const LineNameStudent = styled("div")(({ theme }) => ({
  backgroundColor: "black",
  height: "1px",
  width: "100%",
}));

export const ObjectiveBox = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  margin: `${147 * zoomfactor}px ${253 * zoomfactor}px ${40 * zoomfactor}px ${253 * zoomfactor}px`,
  backgroundColor: COLORS.DIDACTO_GREY,
  boxSizing: "border-box",
}));

export const ObjectiveTitle = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${46 * zoomfactor}px`,
  fontFamily: "TisaSansPro-Bold",
  color: "white",
  backgroundColor: "black",
  padding: `${5 * zoomfactor}px ${20 * zoomfactor}px`,
  width: "20%",
}));

export const Objective = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${46 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
  padding: `${20 * zoomfactor}px ${20 * zoomfactor}px ${10 * zoomfactor}px ${20 * zoomfactor}px`,
}));

export const ExercisesContainer = styled(Box)(({ theme }) => ({
  flex: "1",
  lineHeight: "1",
}));

export const ExerciseContainer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  position: "relative",
  paddingTop: `${44 * zoomfactor}px`,
  cursor: "grab",
}));

export const SpacerLeft = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  margin: `0 ${21 * zoomfactor}px 0 ${132 * zoomfactor}px`,
  width: `${100 * zoomfactor}px`,
}));

export const BoxTitleExercise = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const BoxNumberPoints = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  paddingLeft: `${10 * zoomfactor}px`,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: COLORS.DIDACTO_DARK_GREY,
}));

export const BoxNumberRocket = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  display: "flex",
  gap: "16px",
}));

export const Rocket = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  "& .MuiSvgIcon-root": {
    fontSize: `${60 * zoomfactor}px`,
  },
  paddingTop: `${10 * zoomfactor}px`,
}));

export const BoxNumber = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const ExerciseNumber = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${50 * zoomfactor}px`,
  fontFamily: "TisaSansPro-Bold",
}));

export const ExerciseImage = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: `${1959 * zoomfactor}px`,
  "& img": {
    width: "100%",
  },
  paddingTop: `${10 * zoomfactor}px`,
}));

export const ExercisePoints = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontFamily: "TisaSansPro",
  fontSize: `${50 * zoomfactor}px`,
  display: "flex",
  justifyContent: "end",
  alignItems: "end",
}));

export const PointsContainer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  display: "flex",
  justifyContent: "flex-end",
  width: `${100 * zoomfactor}px`,
  alignItems: "center",
}));

export const PointsTextField = styled(TextField)<ContainerProps>(({ theme, zoomfactor }) => ({
  zIndex: "3",
  "& .MuiInputBase-root": {
    fontSize: `${50 * zoomfactor}px`,
  },
  "& .MuiInputBase-input": {
    padding: `${5 * zoomfactor}px 0`,
    textAlign: "center",
  },
}));

export const TotalPointsContainer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  paddingRight: `${142 * zoomfactor}px`,
}));

export const TotalPoints = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: `${263 * zoomfactor}px`,
  fontSize: `${50 * zoomfactor}px`,
  paddingTop: `${50 * zoomfactor}px`,
  fontFamily: "TisaSansPro-Bold",
  borderTop: `${8 * zoomfactor}px solid black`,
  textAlign: "end",
}));

export const Copyright = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  margin: `0 ${142 * zoomfactor}px ${50 * zoomfactor}px ${263 * zoomfactor}px`,
  display: "flex",
  flexDirection: "column",
}));

export const TypographyCopyright = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${33 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
  cursor: "pointer",
}));

export const AddExercise = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  padding: "0 24px",
  cursor: "pointer",
  opacity: "0.8",
}));

export const LineAddExercise = styled("div")(({ theme }) => ({
  backgroundColor: "black",
  height: "1px",
  flex: "1",
}));

export const AddExerciseContainer = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  position: "absolute",
  bottom: `${-76 * zoomfactor}px`,
  left: "0",
  height: "38px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "1",
}));

export const AddExerciseContainerTopPage = styled(AddExerciseContainer)<ContainerProps>(({ theme, zoomfactor }) => ({
  position: "absolute",
  left: "0",
  top: `${-50 * zoomfactor}px`,
}));

export const ExamSheetContainerPdf = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: `${2480 * zoomfactor}px`,
  margin: "0",
  aspectRatio: "1 / 1.414",
  overflow: "hidden",
  position: "relative",
  display: "flex",
  flexDirection: "column",
}));

export const ExerciseContainerPdf = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  paddingTop: `${88 * zoomfactor}px`,
  display: "flex",
  width: "100%",
  position: "relative",
}));

export const PointsContainerPdf = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  paddingRight: "20px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const PointsPdf = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  width: `${263 * zoomfactor}px`,
  fontSize: `${50 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
  textAlign: "end",
}));

export const TypographyCopyrightPdf = styled(Box)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${33 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
  display: "flex",
  justifyContent: "space-between",
}));
